var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Badge } from '@patternfly/react-core/dist/dynamic/components/Badge';
import { MenuToggle } from '@patternfly/react-core/dist/dynamic/components/MenuToggle';
import { Select } from '@patternfly/react-core/dist/dynamic/components/Select';
import { SelectList } from '@patternfly/react-core/dist/dynamic/components/Select';
import { SelectOption } from '@patternfly/react-core/dist/dynamic/components/Select';
import omit from 'lodash/omit';
import { isFilterValue } from './TextFilter';
var CheckboxFilter = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.value, value = _c === void 0 ? [] : _c, onChange = _a.onChange, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, props = __rest(_a, ["items", "value", "onChange", "isDisabled"]);
    var placeholder = props.placeholder, className = props.className;
    var _e = useState(false), isExpanded = _e[0], setExpanded = _e[1];
    var onSelect = function (event, selection) {
        var shouldRemove = value.includes(selection);
        var newSelection = shouldRemove
            ? value.filter(function (v) {
                if (isFilterValue(selection)) {
                    return v !== selection.value;
                }
                return v !== selection;
            })
            : __spreadArray(__spreadArray([], value, true), [selection], false);
        onChange === null || onChange === void 0 ? void 0 : onChange(event, newSelection, selection);
    };
    var toggle = function (toggleRef) { return (_jsxs(MenuToggle, { "aria-label": "Options menu", isDisabled: isDisabled, onClick: function () { return setExpanded(function (prev) { return !prev; }); }, ref: toggleRef, isExpanded: isExpanded, isFullWidth: true, children: [placeholder, value.length > 0 && (_jsx(Badge, { className: "pf-v6-u-ml-sm", isRead: true, children: value.length }))] })); };
    return (_jsx(Select, { role: "menu", toggle: toggle, className: className, onOpenChange: function (isExpanded) { return setExpanded(isExpanded); }, onSelect: function (event, value) { return onSelect(event, value); }, isOpen: isExpanded, ouiaId: placeholder, popperProps: { appendTo: 'inline' }, children: _jsx(SelectList, { "aria-label": "Options menu", children: items.map(function (_a, key) {
                var optionValue = _a.value, onClick = _a.onClick, label = _a.label, id = _a.id, item = __rest(_a, ["value", "onClick", "label", "id"]);
                return (_createElement(SelectOption, __assign({ hasCheckbox: true, isSelected: value.includes(optionValue) }, omit(item, 'onChange'), { key: id || key, value: String(optionValue || id || key), onClick: function (e) {
                        onClick === null || onClick === void 0 ? void 0 : onClick(e, __assign({ value: optionValue, label: label, id: id }, item), key);
                    } }), label));
            }) }) }));
};
export default CheckboxFilter;
//# sourceMappingURL=CheckboxFilter.js.map